import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'

import { AppDispatch, RootState } from 'redux/store'
import { goalbankAPI, useGET_goalByIdQuery, useGET_goalClustersQuery } from 'redux/api/goalbankApi'
import { clearAllFilters } from 'redux/ui/goalbankUI'
import TuneIcon from '@mui/icons-material/Tune'

import PageHeading from 'components/atoms/PageHeading'
import ExtraFiltersGoalbank from 'components/organisms/forms/tableFilters/goalbank/ExtraFilters'

import { initialValues } from 'utils/tableFilterModels/goalbankTableFilterModel'
import { Box, Button, Grid } from '@mui/material'
import { ArrowCircleDownOutlined, ArrowCircleRightOutlined, Check, CheckBoxOutlined, CheckBoxRounded, ZoomIn} from '@mui/icons-material'
import { PRIMARY_BLUE, PRIMARY_LIGHT_BLUE, PRIMARY_LIGHT_GREEN, PRIMARY_LIGHT_PINK, PRIMARY_LIGHT_YELLOW, PRIMARY_MEDIUM_BLUE } from 'utils/customizedTheme'
import { translateGradeLevel } from 'utils/helpers'
import { Form, Formik } from 'formik'
import { FaEraser } from 'react-icons/fa'
import DialogPopup from 'components/molecules/DialogPopup'
import Goal from 'components/utilized/goalbank/Goal'
import { t } from 'i18next'
import Unit from 'components/utilized/goalbank/Unit'
import i18n from 'i18n'


interface IProps {
  hasSelection?: boolean
  visibleSections?: string[]
  disabledSections?: string[]
  setupPrefix?: string,
  filters?: any
}

const GoalbankPage: FC<IProps> = ({hasSelection=false, disabledSections=[], visibleSections=[], filters={}, setupPrefix=""}) => {
  const { t } = useTranslation()
  const reduxKey = 'goalbank'
  const dispatch = useDispatch<AppDispatch>()
  
  const goalbankSelectedItems = (item) => {
      let count=0;
      Object.keys(item["selection"]).forEach(k => {
        count+=item["selection"][k].length;
      })
      return count;
  }

  const clusterFilters = {
    search: useSelector((state: RootState) => state[reduxKey].tableFilters.search),
    grade_level: useSelector((state: RootState) => state[reduxKey].tableFilters.grade_level),
    subject: useSelector((state: RootState) => state[reduxKey].tableFilters.subject),
    content_area: useSelector((state: RootState) => state[reduxKey].tableFilters.content_area),
    domain: useSelector((state: RootState) => state[reduxKey].tableFilters.domain),
    complexity: useSelector((state: RootState) => state[reduxKey].tableFilters.complexity),
  }

  const { data: grades } = useGET_goalClustersQuery({ page: 1, ...clusterFilters })

  const [showForm, setShowForm] = useState(false)
  const [selectedGrade, setSelectedGrade] = useState(null)
  const [selectedSubject, setSelectedSubject] = useState(null)
  const [selectedSubjectMap, setSelectedSubjectMap] = useState(null)
  const [selectedDomain, setSelectedDomain] = useState(null)
  const [selectedCluster, setSelectedCluster] = useState(null)
  const [selectedGoal, setSelectedGoal] = useState(null)
  const [selectedUnit, setSelectedUnit] = useState(null)
  const [filterGoal, setFilterGoal] = useState("")

  const goalbankSelection = useSelector((state: RootState) => state[reduxKey].goalbankSelection)
  const curriculumSelection = useSelector((state: RootState) => state[reduxKey].curriculumSelection)

  useEffect(() => {
    if(parseInt(clusterFilters.grade_level)>=0 && clusterFilters.grade_level !== selectedGrade)setSelectedGrade(clusterFilters.grade_level);
    if(clusterFilters.subject !== selectedSubject)setSelectedSubject(clusterFilters.subject);
    if(clusterFilters.domain !== selectedDomain)setSelectedDomain(clusterFilters.domain);
  }, [clusterFilters.grade_level, clusterFilters.subject, clusterFilters.domain])



  const { data: filterGoalData } = useGET_goalByIdQuery(filterGoal,{skip: !filterGoal})

  useEffect(() => {
    if(filters){
      if(parseInt(filters.grade_level)>=0)setSelectedGrade(filters.grade_level);
      if(parseInt(filters.subject)>0)setSelectedSubject(filters.subject);
      if(parseInt(filters.domain)>0)setSelectedDomain(filters.domain);
      if(parseInt(filters.cluster)>0)setSelectedCluster(filters.cluster);
      if(parseInt(filters.goal)>0){setFilterGoal(filters.goal);}
    }
  }, [filters])

  useEffect(() => {
    if(filterGoalData){
      setSelectedGoal(filterGoalData)
    }else{
      setSelectedGoal(null)
    }
  }, [filterGoalData])



  

  return (
    <>
    <Box className="transparent-background" sx={hasSelection ? {} : { padding: '20px' }}>

     { hasSelection && <div style={{position:'relative'}}><TuneIcon sx={{ 
           position: 'absolute',
           top: '-60px', 
           left: '0px',
           fontSize: '1.9rem', 
           bottom: '-5px', 
           cursor: 'pointer' }} 
          onClick={() => setShowForm(!showForm)}/></div> } 

      { !hasSelection && <>
        <PageHeading title={t('common.goalbank')} icon={
          <TuneIcon sx={{ fontSize: '1.9rem', position: 'relative', bottom: '-5px', cursor: 'pointer' }} 
          onClick={() => setShowForm(!showForm)}/>
        } />

      </> }
      {/*<Box sx={{ background: '#fff', marginTop: '20px' }} className="thick-border">*/}

      {showForm &&
        <Formik initialValues={initialValues} validationSchema={null} onSubmit={null}>
          {({ handleReset }) => (
            <Form style={{ width: '100%', marginTop: '20px' }}>
              <Grid spacing={2} container>
                <ExtraFiltersGoalbank setupPrefix={setupPrefix} />
                <Grid item xs={3} xl={3} style={{ display: "flex" }}>
                    <Button
                      disableElevation
                      variant='contained'
                      color='error'
                      onClick={() => {
                        dispatch(clearAllFilters())
                        handleReset()
                      }}
                      aria-label='close'
                    >
                      <FaEraser />
                      <span style={{ marginLeft: '0.5rem', display: 'inline-block' }}>{`${t(
                        'common.clear-filters',
                      )}`}</span>
                    </Button>
                  </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      }
        


        {selectedGoal && <DialogPopup
          title={t('common.goalbank')}
          open={true}
          onClose={() => setSelectedGoal(null)}
          popupWidth={'1000px'}
        >
          <Goal 
            goal={selectedGoal} 
            hasSelection={hasSelection} 
            disabledSections={disabledSections}
            visibleSections={visibleSections} 
            setupPrefix={setupPrefix} 
            handleSelectUnit={(id) => {
              setSelectedGoal(null)
              setSelectedUnit(id)
            }}
            />
        </DialogPopup>
        }

        {selectedUnit && <DialogPopup
          title={t('common.curriculum-library')}
          open={true}
          onClose={() => setSelectedUnit(null)}
          popupWidth={'1000px'}
        >
          <Unit 
            unitId={selectedUnit} 
            hasSelection={hasSelection}  
            disabledSections={disabledSections} 
            visibleSections={visibleSections} 
            setupPrefix={setupPrefix} />
        </DialogPopup>
        }


        { grades && 
          <Box sx={{ marginTop: "20px", paddingBottom: "20px" }}>
            <Grid spacing={2} container>
            {
              grades.map(grade => <Grid item key={`grade_level_${grade.grade_level}`} 
                  xs={12} lg={(selectedGrade!==null && selectedGrade===grade.grade_level) ? 12 : 2}>

                  <div 
                    className={`goalbank-box ${(selectedGrade!==null && selectedGrade===grade.grade_level) ? 'goalbank-selected' : ''}`} 
                    onClick={() => setSelectedGrade((selectedGrade!==null && selectedGrade===grade.grade_level) ? null : grade.grade_level)}>
                    <div className="goalbank-box-title">
                      {(selectedGrade!==null && selectedGrade===grade.grade_level) ? <ArrowCircleDownOutlined /> : <ArrowCircleRightOutlined />} 
                      <span>{translateGradeLevel(grade.grade_level)}</span>
                    </div>
                    <div className="goalbank-content"><Grid spacing={2} container>
                      {
                        grade.subjects.map(subject => <Grid item key={`subject_${subject.id}`} 
                            xs={12} lg={selectedSubject===subject.id ? 12 : 3}>
                                <div className={`goalbank-box ${selectedSubject===subject.id ? 'goalbank-selected' : ''}`} 
                                  style={{backgroundColor: PRIMARY_LIGHT_BLUE}}
                                  onClick={(e) => {
                                      e.stopPropagation()  
                                      setSelectedSubject(selectedSubject===subject.id ? null : subject.id)
                                  }}>
                                      <div className="goalbank-box-title">
                                        {selectedSubject===subject.id ? <ArrowCircleDownOutlined /> : <ArrowCircleRightOutlined />} 
                                        <span>{t('common.standards-for')} {subject.title}</span>
                                      </div>
                                      <div className="goalbank-content"><Grid spacing={2} container>
                                        
                                        {
                                          subject.domains.map(domain => <Grid item key={`domain_${domain.id}`} 
                                              xs={12} lg={selectedDomain===domain.id ? 9 : 3}>
                                                  <div className={`goalbank-box ${selectedDomain===domain.id ? 'goalbank-selected' : ''}`} 
                                                    style={{backgroundColor: PRIMARY_LIGHT_PINK}}
                                                    onClick={(e) => {
                                                        e.stopPropagation()  
                                                        setSelectedDomain(selectedDomain===domain.id ? null : domain.id)
                                                    }}>
                                                        <div className="goalbank-box-title">
                                                          {selectedDomain===domain.id ? <ArrowCircleDownOutlined /> : <ArrowCircleRightOutlined />} 
                                                          <span>{domain.title}</span>
                                                        </div>
                                                        <div className="goalbank-content"><Grid spacing={2} container>
                                                          {
                                                            domain.clusters.map(cluster => <Grid item key={`cluster_${cluster.id}`} 
                                                                xs={12} lg={selectedCluster===cluster.id ? 8 : 4}>
                                                                    <div className={`goalbank-box ${selectedCluster===cluster.id ? 'goalbank-selected' : ''}`} 
                                                                      style={{backgroundColor: PRIMARY_LIGHT_YELLOW}}
                                                                      onClick={(e) => {
                                                                          e.stopPropagation();
                                                                          setSelectedCluster(selectedCluster===cluster.id ? null : cluster.id)
                                                                      }}>
                                                                          <div className="goalbank-box-title">
                                                                            {selectedCluster===cluster.id ? <ArrowCircleDownOutlined /> : <ArrowCircleRightOutlined />} 
                                                                            <span><b>{cluster.code}</b> {cluster.title}</span>
                                                                          </div>
                                                                          <div className="goalbank-content"><Grid spacing={2} container>
                                                                                {
                                                                                  cluster.goals.map(goal => <Grid item key={`goal_${goal.id}`} 
                                                                                      xs={12} lg={4}>
                                                                                          <div className={`goalbank-box ${selectedGoal?.id===goal.id ? 'goalbank-selected' : ''}`} 
                                                                                            style={{backgroundColor: PRIMARY_LIGHT_GREEN}}
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation(); 
                                                                                                setSelectedGoal(selectedGoal?.id===goal.id ? null : goal)
                                                                                            }}>
                                                                                                <div className="goalbank-box-title">
                                                                                                  <span><b>{goal.display_code}</b> {goal.title}</span>
                                                                                                </div>
                                                                                                
                                                                                                <div style={{ height: "20px" }}>
                                                                                                    {goal.id in goalbankSelection && 
                                                                                                    goalbankSelectedItems(goalbankSelection[goal.id])>0 &&
                                                                                                    <div className="goalbank-selection">
                                                                                                      <CheckBoxOutlined />
                                                                                                      {goalbankSelectedItems(goalbankSelection[goal.id])}
                                                                                                    </div>}
                                                                                                    <ZoomIn className="goalbank-zoom" />
                                                                                                </div>
                                                                                          </div>
                                                                                    </Grid>
                                                                                  )
                                                                                }

                                                                              </Grid></div>
                                                                    </div>
                                                              </Grid>
                                                            )
                                                          }

                                                        </Grid></div>
                                                  </div>
                                            </Grid>
                                          )
                                        }


                                        <Grid item xs={12}> 
                                          <div className={`goalbank-box ${selectedSubjectMap===subject.id ? 'goalbank-selected' : ''}`} 
                                            style={{backgroundColor: PRIMARY_MEDIUM_BLUE}}
                                            onClick={(e) => {
                                                e.stopPropagation()  
                                                setSelectedSubjectMap(selectedSubjectMap===subject.id ? null : subject.id)
                                            }}>
                                                <div className="goalbank-box-title">
                                                  {selectedSubjectMap===subject.id ? <ArrowCircleDownOutlined /> : <ArrowCircleRightOutlined />} 
                                                  <span>{t('common.curriculum-map')}</span>
                                                </div>
                                                <div className="goalbank-content"><Grid spacing={2} container>
                                                  

                                                {
                                                    subject.units.map(unit => <Grid item key={`unit_${unit.id}`} xs={12} lg={3}>
                                                            <div className={`goalbank-box ${selectedUnit===unit.id ? 'goalbank-selected' : ''}`} 
                                                              style={{backgroundColor: PRIMARY_BLUE}}
                                                              onClick={(e) => {
                                                                  e.stopPropagation()  
                                                                  setSelectedUnit(selectedUnit===unit.id ? null : unit.id)
                                                              }}>
                                                                  <div className="goalbank-box-title">
                                                                      <span><b>{t('setup-syllabus-main.unit')} {unit.number}:</b> {unit.title}</span>
                                                                  </div>

                                                                  <div style={{ height: '30px' }}>                                        
                                                                  {unit.id in curriculumSelection && 
                                                                      goalbankSelectedItems(curriculumSelection[unit.id])>0 &&
                                                                        <div className="goalbank-selection">
                                                                          <CheckBoxOutlined />
                                                                              {goalbankSelectedItems(curriculumSelection[unit.id])}
                                                                        </div>}

                                                                  <ZoomIn className="goalbank-zoom" />
                                                                  </div>
                                                            </div>
                                                        </Grid>)
                                                  }

                                                  
                                                </Grid></div>

                                            </div>  
                                          </Grid>
                                        

                                      </Grid></div>
                                 </div>
                          </Grid>
                        )
                      }
                    </Grid></div>
                  </div>   
                  
              </Grid>)
            }
            </Grid>  
          </Box>
        }
        
      </Box>
    {/* </Box> */}
    </>
  )
}
export default GoalbankPage


                                